export const portfolio = [
  {
    slug: "house-of-chi",
    sector: "Fashion / D2C",
    engagementType: "Website redesign · Performance marketing · Growth strategy",
    problem: "Turning a digital storefront into a growth engine.",
    approach:
      "House of Chi is a contemporary women's fashion brand with strong product potential but an underperforming digital storefront and paid acquisition engine. GroundWork led the digital experience and performance marketing approach, bringing the offer, storefront and acquisition engine together around a clearer growth thesis.",
    result: "8× MRR growth in 3 months",
    currentStage: "8× MRR growth in 3 months",
    accent: "#E26D5C",
    cover:
      "https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?auto=format&fit=crop&w=1600&q=80",
  },
  {
    slug: "legacy-manufacturer-b2c",
    sector: "Manufacturing",
    engagementType: "Channel strategy · Product prioritisation · Launch narrative",
    problem: "Building the consumer growth layer for a legacy manufacturer.",
    approach:
      "A legacy B2B manufacturing company with decades of production depth, historically sold through distributors. GroundWork is helping map the transition toward clearer B2C and B2B channel architecture, including product prioritisation, catalogue direction, channel strategy and launch narrative.",
    currentStage: "Strategy and launch development underway.",
    accent: "#729B79",
    cover:
      "https://images.unsplash.com/photo-1567789884554-0b844b597180?auto=format&fit=crop&w=1600&q=80",
  },
];

export const getPortfolioBySlug = (slug) =>
  portfolio.find((p) => p.slug === slug);
